module.exports = __webpack_public_path__ + "img/user-avatar.259dde4c.png";